import { render } from "./CostIncludesTab.vue?vue&type=template&id=09b77518&scoped=true"
import script from "./CostIncludesTab.vue?vue&type=script&lang=js"
export * from "./CostIncludesTab.vue?vue&type=script&lang=js"

import "./CostIncludesTab.vue?vue&type=style&index=0&id=09b77518&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09b77518"]])

export default __exports__